import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HTTPError } from 'services/api/entities';
import { Nullable } from 'types';

type ErrorContentProps = {
  error: Nullable<HTTPError>;
  closeButtonAction: () => void;
};

const ErrorContent = ({ error, closeButtonAction }: ErrorContentProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <DialogContent
        data-testid="alert-error"
        sx={{ padding: theme.spacing(1, 3) }}
      >
        <DialogContentText>{error?.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={closeButtonAction}
          data-testid="base-dialog-close-button"
        >
          {t('general:action:cancel')}
        </Button>
      </DialogActions>
    </>
  );
};

export default ErrorContent;
